import React from 'react';
import './FullSidebar.css';
import { Link } from "react-router-dom";
import { ReactComponent as HomeIcon } from '../../assets/Icons/Home.svg';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

const FullSidebar = ({ 
    sidebarItems, 
    favorites, 
    onAddFavorite, 
    onRemoveFavorite, 
    onNavigateToFavorite,
    showAddFavoriteDialog,
    setShowAddFavoriteDialog,
    newFavoriteName,
    setNewFavoriteName,
    isAddingFavorite
}) => {
    return (
        <aside className="full-sidebar">
            <div className="header-title">
                <Link to='/dashboard/home' className="logo-link">
                    Frazza
                </Link>
            </div>

            <nav className="sidebar-section navigation-section">
                <h3 className="sidebar-title">Navigation</h3>
                <ul className="sidebar-nav">
                    {sidebarItems.map((item, index) => {
                        const label = getLabelFromIcon(item.icon);
                        return (
                            <li
                                key={index}
                                className={`sidebar-nav-item ${item.className}`}
                                onClick={item.command}
                            >
                                {label === 'Home' ? (
                                    <HomeIcon className={`sidebar-nav-icon ${item.className.includes('active') ? 'active' : ''}`} />
                                ) : (
                                    <i className={`${item.icon} sidebar-nav-icon`} />
                                )}

                                <span>{label}</span>
                            </li>
                        );
                    })}
                </ul>
            </nav>

            <div className="sidebar-section favorites-section">
                <div className="favorites-header">
                    <h3 className="sidebar-title">Shortcuts</h3>
                    <Button 
                        icon="pi pi-plus" 
                        className="p-button-text p-button-rounded add-favorite-button" 
                        onClick={() => setShowAddFavoriteDialog(true)}
                        aria-label="Add favorite"
                    />
                </div>
                <div className="favorites-list">
                    {favorites.map((favorite, index) => (
                        <div key={index} className="favorite-item">
                            <button 
                                className="favorite-link"
                                onClick={() => onNavigateToFavorite(favorite)}
                            >
                                {favorite.name}
                            </button>
                            <Button 
                                icon="pi pi-times" 
                                className="p-button-text p-button-rounded remove-favorite"
                                onClick={() => onRemoveFavorite(favorite)}
                                aria-label="Remove favorite"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Add Favorite Dialog */}
            <Dialog 
                visible={showAddFavoriteDialog} 
                onHide={() => setShowAddFavoriteDialog(false)}
                header="Add to Favorites"
                modal
                className="add-favorite-dialog"
            >
                <div className="p-field">
                    <label htmlFor="favoriteName">Name this shortcut</label>
                    <InputText
                        id="favoriteName"
                        value={newFavoriteName}
                        onChange={(e) => setNewFavoriteName(e.target.value)}
                        placeholder="Enter a name for this page"
                        autoFocus
                    />
                </div>
                <div className="dialog-footer">
                    <Button 
                        label="Cancel" 
                        icon="pi pi-times" 
                        onClick={() => setShowAddFavoriteDialog(false)} 
                        className="p-button-text"
                    />
                    <Button 
                        label="Add" 
                        icon="pi pi-check" 
                        onClick={onAddFavorite} 
                        loading={isAddingFavorite}
                        disabled={!newFavoriteName.trim()}
                    />
                </div>
            </Dialog>
        </aside>
    );
};

const getLabelFromIcon = (iconClass) => {
    const map = {
        'pi-home': 'Home',
        'pi-heart': 'Dates',
        'pi-objects-column': 'Organization',
        'pi-clipboard': 'Tracker',
    };

    const match = Object.keys(map).find(key => iconClass.includes(key));
    return match ? map[match] : '';
};

export default FullSidebar;
